import { render } from "./BlockedModal.vue?vue&type=template&id=0dfac110&ts=true"
import script from "./BlockedModal.vue?vue&type=script&lang=ts"
export * from "./BlockedModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__